import { render, staticRenderFns } from "./AssociatedTaxis.vue?vue&type=template&id=6da95aaa&scoped=true&"
import script from "./AssociatedTaxis.vue?vue&type=script&lang=js&"
export * from "./AssociatedTaxis.vue?vue&type=script&lang=js&"
import style0 from "./AssociatedTaxis.vue?vue&type=style&index=0&id=6da95aaa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da95aaa",
  null
  
)

export default component.exports